import '../lib/typedef';
import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/expense';

export default {
	/**
	 * Fetch All Expenses
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} params.date_since Date Since
	 * @param {string} params.date_until Date Until
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getExpenses(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Store/Create Expenses
	 *
	 * @param {Object} params
	 * @param {'manual'} params.type Type
	 * @param {string} params.name Name
	 * @param {string} params.amount Amount
	 * @param {string} params.date Date
	 * @param {string} params.product_id Product ID
	 * @param {string[]} params.tags Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	store(params, cb, errorCb) {
		const url = `${endpoint}`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Delete Expenses
	 *
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Delete Expenses
	 *
	 * @param {Object} params
	 * @param {string[]} params.expense_ids Array of Expense ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDelete(ids = [], cb, errorCb) {
		const url = endpoint;

		const idsJSON = JSON.stringify(ids);
		const params = {
			expense_ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Export Expenses
	 *
	 * @param {Object} params
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	export(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Single Update Expenses
	 *
	 * @param {string} id Contact ID
	 * @param {Object} params
	 * @param {'manual' | 'automatic' } params.type Type
	 * @param {string} params.name Name
	 * @param {string} params.amount Amount
	 * @param {string} params.date Date
	 * @param {string} params.product_id Product ID
	 * @param {string[]} params.tags Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Update Expenses
	 *
	 * @param {Object} params
	 * @param {string[]} params.expense_ids Array of expenses ID
	 * @param {Object} params.expense_data Expense Data
	 * @param {string} params.expense_data.name  Expense Data Name
	 * @param {string} params.expense_data.product  Expense Data Product ID
	 * @param {string} params.expense_data.amount  Expense Data Amount
	 * @param {string[]} params.expense_data.tags  Expense Data Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	updateBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/* ===== EXPENSE SOURCE ===== */
	/**
	 * Fetch All Expenses Source
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.product_id] Product ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getExpenseSource(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/source?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Store/Create Expenses
	 *
	 * @param {Object} params
	 * @param {Object} params.data Data
	 * @param {'automatic' } params.type Type
	 * @param {string} params.name Name
	 * @param {string} params.product_id Product ID
	 * @param {string} params.data.ad_account_name Ad Account Name
	 * @param {string} params.data.ad_account_id Ad Account ID
	 * @param {string} params.data.campaign_id Campaign ID
	 * @param {string} params.data.campaign_name Campaign Name
	 * @param {string[]} params.tags Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	// storeSource(params, cb, errorCb) {
	// 	const url = `${endpoint}/source`;
	// 	client
	// 		.post(url, params)
	// 		.then((response) => {
	// 			if (cb) cb(response.data);
	// 		})
	// 		.catch((e) => {
	// 			if (errorCb) errorCb(e);
	// 		});
	// },

	/**
	 * Single Update Expenses
	 *
	 * @param {string} id Contact ID
	 * @param {Object} params
	 * @param {'automatic' } params.type Type
	 * @param {string} params.name Name
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	updateSource(id, params, cb, errorCb) {
		const url = `${endpoint}/source/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Delete Expenses Source
	 *
	 * @param {Object} params
	 * @param {string[]} params.expense_ids Array of Expense ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDeleteSource(ids = [], cb, errorCb) {
		const url = `${endpoint}/source`;

		const idsJSON = JSON.stringify(ids);
		const params = {
			expense_source_ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},
};
